import { DatePipe } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MyDatePickerModule } from 'mydatepicker';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgxUiLoaderConfig, NgxUiLoaderModule } from 'ngx-ui-loader';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CodeComponent } from './core/code.component';
import { FooterComponent } from './core/footer/footer.component';
import { HeaderComponent } from './core/header/header.component';
import { LoginComponent } from './core/login/login.component';
import { ImmigrationService } from './modules/common/associates/service/immigration.service';
import { PersonInfoService } from './modules/common/associates/service/personinfo.service';
import { LocalSuperiorService } from './modules/consecrated/master-data-setup/service/localSuperiors.service';
import { MajorSuperiorService } from './modules/consecrated/master-data-setup/service/majorSuperiors.service';
import { BgCheckDecisionService } from './modules/fingerprint/fingerprint-summary/service/bgCheckDecision.service';
import { BGCheckResponseService } from './modules/fingerprint/fingerprint-summary/service/bgCheckResponse.service';
import { BGCheckResponseAttachmentsService } from './modules/fingerprint/fingerprint-summary/service/bgCheckResponseAttachmentsService';
import { DocumentService } from './modules/fingerprint/fingerprint-summary/service/document.service';
import { InquiryStatusService } from './modules/fingerprint/fingerprint-summary/service/inquiryStatusService';
import { JobTitlesService } from './modules/fingerprint/fingerprint-summary/service/jobtitles.service';
import { JWTService } from './modules/fingerprint/fingerprint-summary/service/jwt.service';
import { LiveScanDecisionService } from './modules/fingerprint/fingerprint-summary/service/liveScanDecision.service';
import { LiveScanResponseService } from './modules/fingerprint/fingerprint-summary/service/liveScanResponse.service';
import { LivescanResponseAttachmentsService } from './modules/fingerprint/fingerprint-summary/service/livescanResponseAttachmentsService';
import { LocationService } from './modules/fingerprint/fingerprint-summary/service/location.service';
import { MinistryTypeService } from './modules/fingerprint/fingerprint-summary/service/ministryTypeService';
import { SeminarianSearchService } from './modules/seminarian/service/seminarianSearch.service';
import { ProfileService } from './modules/users/admin-profile/service/profile.service';
import { OrganizationService } from './modules/users/admin-roles/service/organization.service';
import { ParticipantsService } from './modules/users/admin-roles/service/participants.service';
import { RolesService } from './modules/users/admin-roles/service/roles.service';
import { ApplicationService } from './modules/users/admin-users/service/application.service';
import { UserService } from './modules/users/admin-users/service/user.service';
import { UserRoleProfileService } from './modules/users/admin-users/service/userrole-profile.service';
import { DateTimeFormatPipe } from './shared/pipes/date-time-format.pipe';
import { DatexPipe } from './shared/pipes/datex.pipe';
import { AssignmentService } from './shared/service/assignment.service';
import { AssociateTypesMasterService } from './shared/service/associate-types.service';
import { AttachmentsService } from './shared/service/attachmentsService';
import { ChecklistValueService } from './shared/service/checklist-value.service';
import { CommonService } from './shared/service/common.service';
import { ConsercatedPersonService } from './shared/service/consecrated-person.service';
import { EducationService } from './shared/service/education.service';
import { EmergencyContactService } from './shared/service/emergencyContact.service';
import { HttpErrorHandler } from './shared/service/http-error-handler.service';
import { InquiryService } from './shared/service/inquriy.service';
import { LanguagesService } from './shared/service/languages.service';
import { LoginService } from './shared/service/login.service';
import { MessageService } from './shared/service/message.service';
import { NgxUiLoaderDemoService } from './shared/service/ngx-ui-loader-demo.service';
import { NotesService } from './shared/service/notes.service';
import { AttachmentsNotesService } from './shared/service/attachmentsNotes.service';
import { PagerService } from './shared/service/pager.service';
import { PersonLanguageService } from './shared/service/personLanguage.service';
import { ResourceService } from './shared/service/resource.service';
import { SacramentService } from './shared/service/sacrament.service';
import { SafeEvnTrainingService } from './shared/service/safe-environment.service';
import { SeminarianStatusEntryService } from './shared/service/seminarian-status-entry.service';
import { SeminarianService } from './shared/service/seminarian.service';
import { SeminarianOrdinationService } from './shared/service/seminarianordination.service';
import { SeminarianProgramService } from './shared/service/seminarianprogram.service';
import { SeminarianStatusService } from './shared/service/seminarianstatus.service';
import { StatesService } from './shared/service/states.service';
import { ToasterService } from './shared/service/toaster-service.service';
import { PriestFormationService } from './modules/priest/service/priestFormationService.service';
import { PriestAppraisalService } from './shared/service/priestAppraisal.service';
import { PriestFormationEnrollmentService } from './modules/priest/service/priestFormationEnrollmentService.service';
import { PriestListService } from './modules/priest/service/priestListService.service';
import { ComplainceTypeService } from './modules/priest/service/complainceType.service';
import { OrganizationComplainceService } from './modules/priest/service/organizationComplaince.service';
import { PriestOrdinationService } from './shared/service/priestordination.service';
import { PriestTypeService } from './shared/service/priestType.service';
import { PriestStatusService } from './shared/service/priestStatus.service';
import { SeminarianDetailService } from './shared/service/seminarianDetail.service';
import { StatusInDiocesesService } from './shared/service/status-dioceses.service';
import { MtpApplicationService } from './shared/service/mtp-service/mtp.application.service';
import { MtpStatusLookupService } from './shared/service/mtp-service/mtp-status-lookup.service';
import { MtpLiveScanResponseService } from './shared/service/mtp-service/mtpLiveScanResponse.service';
import { MtpDocumentService } from './shared/service/mtp-service/mtpDocument.service';
import { MtpLivescanAttachmentsService } from './shared/service/mtp-service/mtpLivescanAttachmentsService';
import { MtpLiveScanDecisionService } from './shared/service/mtp-service/mtp-liveScanDecision.service';
import { MtpMinistryTypeService } from './shared/service/mtp-service/mtp-ministryTypeService';
import { MtpSafeEvnTrainingService } from './shared/service/mtp-service/mtpSafe-environment.service';
import { PayrollHrManagerServices } from './modules/hr/service/payrollHrManager.service';
import { ManagerTypeServices } from './modules/hr/service/managersType.service';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input'; 
import { BsDropdownConfig, BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { DeaconStatusService } from './modules/deacon/service/deaconStatus.service';
import { DeaconService } from './modules/deacon/service/deacon.service';
import { ReportService } from './shared/service/report.service';
import { DeaconOrdinationService } from './modules/deacon/service/deaconOrdination.service';
import { OrganizationAddressService } from './shared/service/organizationAddress.service';
import { ShirtSizeService } from './modules/seminarian/service/shirtSize.service';
import { AttachmentsCategoryService } from './shared/service/attachmentsCategory.service';
import { HRCommonService } from './modules/hr/service/hrCommon.service.';
import { NonEmpInfoService } from './modules/hr/service/nonEmpInfo.service';
import { DietaryRestrictionsService } from './shared/service/dietaryRestrictionsService';
import { HealthNotesService } from './shared/service/healthNotesService';
import { DeaconChecklistValueService } from './shared/service/deacon-checklist-value.service';
import { IMaskModule } from 'angular-imask';
import { NgxMaskModule } from 'ngx-mask';
import { RestrictionsProfileService } from './modules/users/admin-roles/service/restrictions-profile.service';
import { PriestStatusTypeService } from './shared/service/priestStatusType.service';
import { StatusCodeLookupService } from './modules/fingerprint/fingerprint-summary/service/Statuscodelookup.service';
import { DeaneryService } from './shared/service/deanery.service';
import { InactivityService } from './shared/service/inactivity.service';
import { TimeoutModalComponent } from './core/timeout-modal/timeout-modal.component';
import { MatDialogModule } from '@angular/material/dialog';
import { DialogService } from './shared/service/dialog.service';
 

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
};

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    HeaderComponent,
    LoginComponent,
    TimeoutModalComponent,
    DatexPipe, DateTimeFormatPipe,
    CodeComponent,
  
  
  ],
  imports: [
    BrowserModule,
    IMaskModule,
    AppRoutingModule,
    FormsModule,
    MyDatePickerModule,
    NgMultiSelectDropDownModule.forRoot(),
    NgxMaskModule.forRoot(),
    HttpClientModule,
    BrowserAnimationsModule, 
		ReactiveFormsModule,
		NgxIntlTelInputModule, 
    BsDropdownModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    MatDialogModule 
   
  ],
  providers: [UserService, HttpErrorHandler, MessageService,
    DatePipe, LoginService, ToasterService, PersonInfoService, PagerService,
    ConsercatedPersonService, InquiryService, ProfileService, UserRoleProfileService,
    RolesService, ParticipantsService, ResourceService, ApplicationService,
    CommonService, AssociateTypesMasterService, NgxUiLoaderDemoService,
    LocalSuperiorService, MajorSuperiorService, JWTService, LocationService,
    SafeEvnTrainingService, OrganizationService, StatesService, LiveScanResponseService,
    LiveScanDecisionService, JobTitlesService, InquiryStatusService, BgCheckDecisionService,
     DocumentService, LivescanResponseAttachmentsService, SacramentService,
    BGCheckResponseService, BGCheckResponseAttachmentsService, SeminarianProgramService, SeminarianStatusService,
    EducationService, SeminarianStatusEntryService, EmergencyContactService, SeminarianOrdinationService,
    AssignmentService, MinistryTypeService, ChecklistValueService, NotesService,AttachmentsNotesService, ImmigrationService, SeminarianService,
    SeminarianSearchService, LanguagesService, PersonLanguageService, AttachmentsService,
    PriestFormationService, PriestAppraisalService,PriestFormationEnrollmentService,PriestListService,
    ComplainceTypeService,OrganizationComplainceService,PriestOrdinationService,PriestTypeService,PriestStatusService,
    SeminarianDetailService,StatusInDiocesesService,
    MtpApplicationService,MtpStatusLookupService,MtpLiveScanResponseService,
    MtpDocumentService,MtpLivescanAttachmentsService,MtpLiveScanDecisionService,
    MtpMinistryTypeService,MtpSafeEvnTrainingService,PayrollHrManagerServices,ManagerTypeServices,StatusCodeLookupService,
    DeaconStatusService,DeaconService, BsDropdownConfig,ReportService,DeaconOrdinationService,OrganizationAddressService,PriestStatusTypeService,
    ShirtSizeService,AttachmentsCategoryService,HRCommonService,NonEmpInfoService,DietaryRestrictionsService,HealthNotesService, DeaconChecklistValueService, RestrictionsProfileService,DeaneryService, InactivityService,DialogService],
  bootstrap: [AppComponent],
  entryComponents: [TimeoutModalComponent]
})
export class AppModule {
  constructor(private translate: TranslateService) {
    translate.setDefaultLang('en');
    translate.use('en');
  }
}
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
